import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getServerTime, useOpenSimuladao } from "../utils";

import {
  doFeedbackRequest,
  doFinishSimulatedRequest,
  doInsertAnswerRequest,
  doOpenSimulatedRequest,
  doRankingRequest,
  doSimulationAverageRequest,
  doSimulationRequest,
  doStartSimulatedRequest,
  doReportRequest,
} from "../index";

import DoSimulated from "./doSimulated";
import LoadingSimulated from "./Loading";
import SimulateStart from "../components/simulateStart";
import SimulatedContainer from "../components/container";
import BlockedCard from "../components/BlockedCard";
import SimulatedHeader from "../components/Header";
import * as S from "./styles";
import RenderModal from "../../components/renderModal";
import ModalLead from "../../components/ModalLead";
import { SUBSCRIPTION_KEY, AULAS_HOJE_URL } from "../../core/storageKeys";

const STEPS = {
  LOADING: -1,
  INFO: 0,
  RUNNING: 1,
  BLOCKED: 4,
};

const Zoing = (props) => {
  const {
    match,
    history,
    doFeedbackRequest,
    isFetchingSimulationSetAnswer,
    isFetchingSimulationStart,
    doFinishSimulatedRequest,
    doStartSimulatedRequest,
    doInsertAnswerRequest,
    doSimulationAverageRequest,
    doReportRequest,
  } = props;

  const simulatedSlug = match.params.slug;

  const [user, setUser] = useState(null);
  const [step, setStep] = useState(-1);
  const [isLoadingSomething, setLoadingSomething] = useState(false);
  const [
    simulated,
    setSimulated,
    simulatedHistory,
    setSimulatedHistory,
    ,
    simulatedError,
  ] = useOpenSimuladao(simulatedSlug, history);

  //Cria um contador com data final no dia seguinte, pra termos a data do servidor atualizada
  const [serverTime, setServerTime] = useState(null);
  const [beforeTimeSimulation, setBeforeTimeSimulation] = useState(false);
  const [, setToggleLeadModal] = useState(false);
  // Incrementado quando o contador do BLOCKED zera, para reavaliar o passo.
  const [refreshToken, setRefreshToken] = useState(0);
  const handleCounterComplete = useCallback(
    () => setRefreshToken((token) => token + 1),
    [],
  );
  // Indica que o usuário clicou em Começar/Continuar nesta sessão.
  // Tentativa em andamento mostra o INFO ("Continuar") até o clique acontecer.
  const [entered, setEntered] = useState(false);

  // Verifica no SimulationLandingEntries (histórico retornado pelo verify) se o
  // usuário já iniciou este simulado — define a label do botão (Começar/Continuar).
  const hasStartedSimulation = !!(
    simulatedHistory && simulatedHistory.startDate
  );

  useEffect(() => {
    const _user = JSON.parse(localStorage.getItem(SUBSCRIPTION_KEY));

    setUser(_user);
  }, []);

  useEffect(() => {
    if (!serverTime) return;

    setBeforeTimeSimulation(
      moment(simulated.endDate).isAfter(new Date(serverTime)),
    );
  }, [serverTime]);

  useEffect(() => {
    // Cancela resultados de uma execução anterior do efeito. Sem isso, quando o
    // usuário clica em Começar/Continuar, este efeito re-roda (entered vira
    // true), mas o getServerTime() da rodada antiga ainda está em voo com o
    // closure de entered=false — ao resolver, ele executava setStep(INFO) e
    // jogava o usuário de volta pra tela de Instructions, sem as questões.
    let cancelled = false;
    async function fetchServerTime() {
      if (!simulated) {
        //history.push("/simulado");
        return;
      }
      const fServerTime = await getServerTime();
      if (cancelled) return;
      setServerTime(fServerTime);

      const isGabaritoReleased = moment(simulated.rankingStartDate).isBefore(
        new Date(fServerTime),
      );

      const isSimulatedStarted =
        simulated.startDate &&
        moment(simulated.startDate).isBefore(new Date(fServerTime));

      const isSimulatedEnded =
        simulated.endDate &&
        moment(simulated.endDate).isBefore(new Date(fServerTime));

      // Tempo limite individual já estourou (mesmo sem finalização manual)
      const isLimitReached =
        simulatedHistory.limitDate &&
        moment(simulatedHistory.limitDate).isBefore(new Date(fServerTime));

      // Tentativa do usuário já encerrada: finalizou manualmente (endDate no
      // histórico) OU o tempo individual dele esgotou (limitDate).
      const userFinished = !!(simulatedHistory.endDate || isLimitReached);

      // Simulado ainda não começou => BLOCKED (tela "o simulado abre em...").
      // Mas se o usuário já entrou na prova nesta sessão, nunca rebaixa pra
      // BLOCKED (ex.: getServerTime instável deixaria isSimulatedStarted=false).
      // A finalização por endDate/limite abaixo continua valendo normalmente.
      if (!entered && simulated.startDate && !isSimulatedStarted) {
        setStep(STEPS.BLOCKED);
        return;
      }

      // Gabarito já liberado. Agora existe a janela em que o gabarito abre
      // enquanto a data final do simulado (endDate) ainda não fechou. Nesse
      // intervalo, se o usuário ainda não terminou (nem manualmente nem por
      // tempo), ele volta pras questões; caso contrário (já terminou, ou a
      // janela global já fechou) segue pro gabarito.
      if (isGabaritoReleased && (isSimulatedEnded || userFinished)) {
        history.push("/craques-enem/gabarito");
        return;
      }

      // Já finalizou OU o tempo limite já passou => vai pro gabarito (rota
      // dedicada), sem passar pelo INFO. Baseado no registro do
      // SimulationLandingEntries (não no flag isStarted, que pode vir false).
      if (userFinished) {
        history.push("/craques-enem/gabarito");
        return;
      }

      // Não participou (sem histórico) + prova já encerrada => perdeu o simulado
      if (
        !(simulatedHistory && simulatedHistory.startDate) &&
        isSimulatedEnded
      ) {
        history.push("/craques-enem/gabarito");
        return;
      }

      // Novo usuário (sem tentativa) OU tentativa em andamento ainda não
      // retomada nesta sessão => INFO (botão "Começar" ou "Continuar").
      if (!entered) {
        setStep(STEPS.INFO);
        return;
      }

      // Usuário clicou em Começar/Continuar => entra na prova
      setStep(STEPS.RUNNING);
    }

    if (simulated) {
      fetchServerTime();
    }

    return () => {
      cancelled = true;
    };
  }, [simulated, simulatedHistory, refreshToken, entered, simulatedSlug]);

  const doStartSimulation = () => {
    setLoadingSomething(true);
    doStartSimulatedRequest(match.params.slug, user).then((response) => {
      // Quem está retomando já tem o simulado carregado (veio do verify). Se o
      // /start não devolver o simulado (ex.: backend recusa reiniciar uma
      // tentativa já em andamento, ou falha de rede), caímos no que já temos em
      // memória pra não travar o usuário na tela de Instructions.
      const startedSimulated = (response && response.simulated) || simulated;
      const startedHistory =
        (response && response.history) || simulatedHistory;

      if (startedSimulated) {
        setSimulated(startedSimulated);
        setSimulatedHistory(startedHistory);
        setEntered(true);

        // Decide o passo aqui mesmo, sem esperar o getServerTime assíncrono do
        // useEffect. Sem isso, a tela INFO re-renderiza no intervalo (o botão
        // vira "Continuar") e as questões só aparecem após o round-trip do /time.
        const isFinished =
          startedSimulated.isFinished ||
          (startedHistory && startedHistory.endDate);

        if (isFinished) {
          history.push("/craques-enem/gabarito");
        } else {
          setStep(STEPS.RUNNING);
        }
      }
      setLoadingSomething(false);
    });
  };

  const getFeedback = () => {
    // Usa o slug da rota (o simulated do redux pode estar vazio => slug undefined
    // => /result com slug inválido estourava 500 ao trocar de step).
    doFeedbackRequest(simulatedSlug);
  };

  const doInsertAnswer = (body) => {
    return doInsertAnswerRequest(body).then((response) => {
      if (response.simulated) {
        setSimulatedHistory(response);
      }

      return response;
    });
  };

  const doFinish = (body) => {
    // Atualiza a interface imediatamente (otimista): marca o fim da tentativa
    // mesmo se a resposta do servidor demorar ou falhar. Isso faz o useEffect
    // re-avaliar o passo e redirecionar pro /gabarito assim que o tempo zera.
    setSimulatedHistory((prev) => ({
      ...(prev || {}),
      endDate: (prev && prev.endDate) || new Date().toISOString(),
    }));

    return doFinishSimulatedRequest(body).then((response) => {
      // Reconcilia com o histórico real (nota, contagens etc.) quando vier ok
      if (response && response.simulated) {
        setSimulatedHistory(response);
      }

      return response;
    });
  };

  const getRanking = (forced) => {
    const { doRankingRequest } = props;
    doRankingRequest(simulatedSlug).then(() => getFeedback());
    doSimulationAverageRequest(simulatedSlug);
  };

  if (!user) {
    return (
      <RenderModal>
        <ModalLead
          toggleModal={() => {
            setToggleLeadModal(false);
            window.location.reload();
          }}
          isSimulatedInfoPage={true}
        />
      </RenderModal>
    );
  }

  // Falha ao carregar o simulado (backend offline/instável). Exibe um retry em
  // vez de redirecionar pra /simulado — o que geraria loop com a landing.
  if (simulatedError) {
    return (
      <SimulatedContainer user={user} name="Simulado">
        <S.BlockedScreen>
          <SimulatedHeader title="Simulado" />
          <S.BlockedSection>
            <BlockedCard
              badgeIcon="⚠️"
              badgeLabel="FALHA DE CONEXÃO"
              title="Não conseguimos carregar o simulado."
              subtitle="Pode ser uma instabilidade momentânea. Verifique sua conexão e tente novamente em instantes."
              actionLabel="Tentar novamente"
              onActionClick={() => window.location.reload()}
            />
          </S.BlockedSection>
        </S.BlockedScreen>
      </SimulatedContainer>
    );
  }

  if (step === STEPS.LOADING) {
    return (
      <S.Container>
        <LoadingSimulated />
      </S.Container>
    );
  }

  if (step === STEPS.BLOCKED) {
    return (
      <SimulatedContainer user={user} name={simulated.name}>
        <S.BlockedScreen>
          <SimulatedHeader simulated={simulated} title="Simulado" />
          <S.BlockedSection>
            <S.BlockedStarYellow>
              <svg
                viewBox="0 0 28.5317 27.1353"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M14.2658 0L17.6336 10.3647H28.5317L19.7149 16.7705L23.0826 27.1353L14.2658 20.7295L5.44907 27.1353L8.81678 16.7705L0 10.3647H10.8981L14.2658 0Z"
                  fill="#F7D518"
                  fillOpacity="0.6"
                />
              </svg>
            </S.BlockedStarYellow>
            <S.BlockedStarBlue>
              <svg
                viewBox="0 0 20.9232 19.8992"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M10.4616 0L12.9313 7.60081H20.9232L14.4576 12.2984L16.9273 19.8992L10.4616 15.2016L3.99598 19.8992L6.46564 12.2984L0 7.60081H7.99197L10.4616 0Z"
                  fill="#0033A0"
                  fillOpacity="0.4"
                />
              </svg>
            </S.BlockedStarBlue>
            <S.BlockedStarRed>
              <svg
                viewBox="0 0 17.119 16.2812"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M8.55951 0L10.5801 6.21885H17.119L11.8289 10.0623L13.8496 16.2812L8.55951 12.4377L3.26944 16.2812L5.29007 10.0623L0 6.21885H6.53888L8.55951 0Z"
                  fill="#D62828"
                  fillOpacity="0.35"
                />
              </svg>
            </S.BlockedStarRed>
            <BlockedCard
              releaseDate={simulated.startDate}
              onComplete={handleCounterComplete}
              onActionClick={() =>
                window.open(AULAS_HOJE_URL, "_blank", "noopener,noreferrer")
              }
            />
          </S.BlockedSection>
        </S.BlockedScreen>
      </SimulatedContainer>
    );
  }

  if (step === STEPS.INFO) {
    return (
      <SimulatedContainer user={user} name={simulated.name}>
        <SimulateStart
          simulated={simulated}
          doStartSimulation={doStartSimulation}
          loading={isFetchingSimulationStart || isLoadingSomething}
          isResuming={hasStartedSimulation}
        />
      </SimulatedContainer>
    );
  }

  if (step === STEPS.RUNNING) {
    return (
      <SimulatedContainer user={user} name={simulated.name}>
        <DoSimulated
          beforeTimeSimulation={beforeTimeSimulation}
          simulated={simulated}
          time={serverTime}
          doStartSimulatedRequest={doStartSimulatedRequest}
          match={match}
          doFinishSimulatedRequest={doFinish}
          simulatedHistory={simulatedHistory}
          doInsertAnswerRequest={doInsertAnswer}
          isFetchingSimulationSetAnswer={isFetchingSimulationSetAnswer}
          getRanking={getRanking}
          history={history}
          doReportRequest={doReportRequest}
        />
      </SimulatedContainer>
    );
  }

  return null;
};

const mapStateToProps = (state) => {
  return {
    user: state.app.data.user,
    simulated: state.simulation.data.simulation,
    ranking: state.simulation.data.ranking,
    average: state.simulation.data.simulation.average,
    feedback: state.simulation.data.feedback,
    simulatedHistory: state.simulation.data.history,
    isFetchingSimulation: state.simulation.ui.isFetchingSimulation,
    isFetchingSimulationOpen: state.simulation.ui.isFetchingSimulationOpen,
    isFetchingSimulationStart: state.simulation.ui.isFetchingSimulationStart,
    isFetchingSimulationSetAnswer:
      state.simulation.ui.isFetchingSimulationSetAnswer,
    isFetchingSimulationRanking:
      state.simulation.ui.isFetchingSimulationRanking,
    isFetchingSimulationFeedback:
      state.simulation.ui.isFetchingSimulationFeedback,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      doStartSimulatedRequest,
      doInsertAnswerRequest,
      doOpenSimulatedRequest,
      doFinishSimulatedRequest,
      doRankingRequest,
      doFeedbackRequest,
      doSimulationRequest,
      doSimulationAverageRequest,
      doReportRequest,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Zoing);
